import { faThumbtack } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
    isFocused: boolean;
    setFocused: (focus: boolean) => void;
};

export default function FocusButton({ isFocused, setFocused }: Props) {
    return (
        <button
            type="button"
            className={`focus-pin-btn${isFocused ? ' pinned' : ''}`}
            onClick={(e) => {
                e.stopPropagation();
                setFocused(!isFocused);
            }}
            title={isFocused ? 'Unpin / stop annotating' : 'Pin & annotate'}
        >
            <FontAwesomeIcon icon={faThumbtack} />
            <span className="focus-pin-label">{isFocused ? 'Pinned' : 'Annotate'}</span>

            <style>{`
                .focus-pin-btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    background: rgba(8, 10, 16, 0.82);
                    backdrop-filter: blur(10px);
                    -webkit-backdrop-filter: blur(10px);
                    border: 1px solid rgba(255, 255, 255, 0.18);
                    border-radius: 10px;
                    color: #f8fafc;
                    font-size: 0.8rem;
                    font-weight: 600;
                    padding: 8px 12px;
                    cursor: pointer;
                    transition: background 0.15s, border-color 0.15s, color 0.15s;
                    font-family: inherit;
                    box-shadow: 0 6px 18px rgba(0,0,0,0.35);
                    pointer-events: auto;
                    -webkit-transform: translateZ(0);
                    transform: translateZ(0);
                    position: relative;
                    z-index: 30;
                }

                .focus-pin-btn:hover {
                    background: rgba(37, 99, 235, 0.88);
                    border-color: transparent;
                    color: white;
                }

                .focus-pin-btn.pinned {
                    background: rgba(37, 99, 235, 0.94);
                    border-color: transparent;
                    color: white;
                }

                .focus-pin-label {
                    font-size: 0.78rem;
                    font-weight: 650;
                    letter-spacing: 0.01em;
                }

                @media (max-width: 768px) {
                    .focus-pin-btn {
                        padding: 8px;
                        border-radius: 50%;
                        width: 36px;
                        height: 36px;
                        justify-content: center;
                    }
                    .focus-pin-label { display: none; }
                }
            `}</style>
        </button>
    );
}
